<template>
  <div>
    <div class="toolbar search-form">
      <el-select v-model="ver" placeholder="版本" :clearable="true" style="width:80px;">
        <el-option label="v2" :value="2"></el-option>
        <el-option label="v1" :value="1"></el-option>
      </el-select>
      <el-input v-model="search" placeholder="输入关键字搜索" style="width:200px;"/>
      <el-button type="primary" @click="batchForm">添加课程</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      @sort-change="handleSort"
    >
      <el-table-column type="selection" width="60"></el-table-column>
      <el-table-column prop="id" label="编号" sortable="custom" width="100"></el-table-column>
      <el-table-column prop="num" label="课程"></el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="ver" label="版本"></el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="updateForm(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
          &nbsp;
          <router-link :to="'pinyinlesson/' + scope.row.id">
            <el-button type="text" size="small">编排课程</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-if="total>pageSize"
    >
    </el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%">
      <ModelForm ref="form"></ModelForm>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <Sidebar :visible.sync="batchVisible" header="批量添加">
      <ModelForm ref="batchform"></ModelForm>
      <div class="text-right">
        <el-button @click="batchVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBatch">确 定</el-button>
      </div>
    </Sidebar>
  </div>
</template>

<script>
import ModelForm from './LessonForm'
import Sidebar from './../../components/Sidebar'
import table from './../../components/mixins/table.js'

export default {
  name: 'IntroList',
  mixins:[table],
  data () {
    return {
      ver: 2,
      search: '',
      multipleSelection: [],
      dialogTitle: '添加课程',
      dialogVisible: false,
      batchVisible: false,
      fetchUrl: 'pinyin_lesson_list'
    }
  },
  components: { ModelForm, Sidebar },
  watch: {
    ver () { this.fetchData() },
    search () { this.fetchData() },
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleFetchConfig (config) {
      Object.assign(config.params, {
        "filter[status]": null,
        "filter[and][0][ver]": this.ver || null,
        "filter[and][0][status]": 1,
        "filter[and][1][or][0][title][like]": this.search || null,
        "filter[and][1][or][1][description][like]": this.search || null,
      })
    },
    createForm () {
      this.dialogVisible = true
      this.dialogTitle = '添加课程'
      setTimeout(() => {
        if (this.$refs.form.form.id) {
          this.$refs.form.reset()
        }
      }, 1)
    },
    submitForm () {
      this.$refs.form.submit().then(res => {
        this.dialogVisible = false
        this.fetchData()
        this.$refs.form.reset()
      })
    },
    updateForm (item) {
      this.dialogVisible = true
      this.dialogTitle = '编辑课程'
      setTimeout(() => {
        this.$refs.form.reset(item)
      }, 10)
    },
    batchForm () {
      this.batchVisible = true;
    },
    submitBatch () {
      this.$refs.batchform.submit().then(() => {
        this.fetchData()
        this.$refs.batchform.reset({level: this.$refs.batchform.form.type})
      })
    },
    handleDelete (item) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.$http.put(this.$urls.pinyin_lesson_update, { status: 0 }, {
          params: {id: item.id}
        }).then(() => {
          this.fetchData()
        })
      })
    }
  }
}
</script>